import { Box } from "@mui/material";
import CesiumMap from "../components/c4/CesiumMap";
import Drawer from "../components/c4/Drawer";

export default function C4Page() {
  return (
    <Box
      sx={{
        width: "100dvw",
        height: "100dvh",
      }}
    >
      <CesiumMap />
      <Drawer />
    </Box>
  );
}
